const ded = `<h1>Acceptable Use Policy</h1>
<h2>DressDown.me</h2>
<p><strong>Effective Date:</strong> 01.05.2025</p>
<h2>General Provisions</h2>
<p>This Acceptable Use Policy (“Policy”) defines acceptable and prohibited uses of the website <a href="https://dressdown.me">https://dressdown.me</a> (“Site”). By using the Site, you agree to comply with this Policy as well as other applicable terms and policies, including the Privacy Policy and Terms of Use.</p>
<h2>Acceptable Use</h2>
<p>Users agree to:</p>
<ul>
  <li>Use the Site only for lawful purposes in accordance with applicable laws of the European Union and other jurisdictions.</li>
  <li>Respect the rights of other users and third parties, including rights to privacy, intellectual property, and personal integrity.</li>
  <li>Provide accurate information when registering and using the Site.</li>
</ul>
<h2>Prohibited Use</h2>
<p>The Site may not be used to:</p>
<ul>
  <li>Violate the law: Upload, publish, or distribute content that violates local, national, or international laws and regulations.</li>
  <li>Harm minors: Post, distribute, or access materials that include images or descriptions of minors in a sexual context, or any actions that may harm minors.</li>
  <li>Spread malware: Transmit viruses, trojans, worms, keyloggers, spyware, or other malicious code.</li>
  <li>Violate intellectual property rights: Post content that infringes copyrights, trademarks, patents, or other third-party intellectual property rights.</li>
  <li>Promote hate or discrimination: Publish content that includes defamation, insults, threats, or discrimination based on race, gender, religion, nationality, disability, sexual orientation, or age.</li>
  <li>Engage in fraud or deception: Participate in scams, phishing, spreading false information, or deceiving other users.</li>
  <li>Compromise security: Attempt unauthorized access to systems, data, or accounts of other users or interfere with the Site’s operation or infrastructure.</li>
</ul>
<h2>Content Standards</h2>
<p>Users agree not to post content that:</p>
<ul>
  <li>Is illegal, harmful, offensive, obscene, or violates public morality.</li>
  <li>Contains false or misleading information.</li>
  <li>Infringes third-party rights, including copyright, trademarks, or privacy rights.</li>
  <li>Promotes violence, hatred, discrimination, or illegal activities.</li>
  <li>Includes sexual content depicting or describing minors.</li>
</ul>
<h2>Age Restrictions</h2>
<p>The Site is intended for individuals aged 18 and older only. We implement age verification measures, including third-party services such as Seon and image analysis technologies like DeepFace, to prevent minors from accessing adult content.</p>
<h2>Violations and Consequences</h2>
<p>In the event of a violation of this Policy, we reserve the right to:</p>
<ul>
  <li>Remove or block access to the violating content.</li>
  <li>Suspend or terminate user access to the Site without prior notice.</li>
  <li>Report the violation to relevant law enforcement authorities if legally required.</li>
  <li>Take any other actions necessary to protect the Site, its users, and comply with the law.</li>
</ul>
<h2>Policy Changes</h2>
<p>We may periodically update this Policy. All changes take effect upon being published on the Site. We recommend reviewing the Policy regularly to stay informed about current terms.</p>
<h2>Contact Information</h2>
<p>If you have any questions or comments regarding this Policy, please contact us:<br>
Email: <a href="mailto:support@dressdown.me">support@dressdown.me</a></p>
`

export default ded
